/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * CreateOrderForPayment Input Action
 */
export class CreateOrderForPaymentInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    public LariToken: string;
    public amount: number;
    public emailAddress: string;
    public merchantAttributesRedirectUrl: string;
    constructor(data:any) {
        this.LariToken= data.token;
        this.amount= data.amount;
        this.emailAddress= data.email;
        this.merchantAttributesRedirectUrl= data.url;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `LARICREATEPAYMENTORDER`;
    public getCacheObjectType = () => 'LARICREATEPAYMENTORDER';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface ICreateOrderForPaymentData {
    URL: string | undefined;
    success: boolean;
    error: string | undefined;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext,inputData:any): Msdyn365.IActionInput => {
    return new CreateOrderForPaymentInput(inputData);
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function createOrderForPayment(input: CreateOrderForPaymentInput, ctx: Msdyn365.IActionContext): Promise<ICreateOrderForPaymentData> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;
    // const { szfPaymentDomain, szfPaymentOutletReference } = ctx.requestContext.app.config;
    const szfPaymentDomain = "https://api-gateway.sandbox.ngenius-payments.com";
    const szfPaymentOutletReference = "OGNjZWM1YmMtMWUzNi00NDkyLWFlNmItMGQ4NDQ5MDdkMTAxOmVmNDQ2NGYxLWI0MTctNDlkOC05ZmZmLTA1YzA1YWQ1Nzk0YQ==";
    // TODO: Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<ICreateOrderForPaymentData[]>('/get/example/id/1', 'get');
    const data = {  
        "action": "PURCHASE",   
        "amount" : { "currencyCode" : "AED", "value" : input.amount },
        "emailAddress" : input.emailAddress,
        "merchantAttributes":{
            "redirectUrl": input.merchantAttributesRedirectUrl
        }
      }
    try{
        const response = await Msdyn365.sendRequest<any>(`${szfPaymentDomain}/transactions/outlets/${szfPaymentOutletReference}/orders`, "post", data, {
            headers: {
                'Content-Type': 'application/vnd.ni-identity.v1+json',
                'authorization': `Basic ${input.LariToken}`
            }
        });
        if(response && (response.status===200 || response.data)){
            return {
                URL: 'Static data from action',
                success: true,
                error: undefined
            };
        }else{
            return { 
                URL: undefined, 
                success: false,
                error: "Something went Wrong, Please try again later"
            };
        }
    }catch(err){
        console.log("Payment error",err)
        return { 
            URL: undefined, 
            success: false,
            error: "Something went Wrong, Please try again later"
        };
    }
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ICreateOrderForPaymentData>>createOrderForPayment,
    // TODO: Give your data action a unique id
    id: 'CreateOrderForPayment',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
